<template>
  <b-badge
    qa="status-badge"
    class="state-badge"
    :class="statusClass"
    pill
  >
    {{ status.name }}
  </b-badge>
</template>

<script>

import { REQUEST_STATES } from '@/api/resources/entityState/request-state'

export default {
    name: 'StudyRequestStatusBadge',
    props: {
        status: { type: Object, required: true }
    },
    data() {
        return {
            invalidStatus: { bgColor: 'red', color: 'white', name: 'global.statusOptions.invalid' }
        }
    },
    computed: {
        statusClass() {
            return this.statusOption.class
        },
        statusOption() {
            return Object.values(REQUEST_STATES).find((state) => state.code === this.status.code) ||
                    this.invalidStatus
        }
    }
}

</script>

<style scoped lang="scss">

.sr-status-badge {
  width: 85px;
}

</style>
